
import { Vue, Component, Prop } from "vue-property-decorator";
import { LOGOUT_USER } from "@/store/ActionTypes";
import { UserTypes } from "@/models/User/UserTypes";
import UserDetails from "@/models/User/UserDetails";

@Component
export default class vHeader extends Vue {
  @Prop() menuShow!: boolean;
  @Prop() userDetails!: UserDetails;

  UserTypes = UserTypes;

  toggleMenu() {
    this.$emit("toggleHeaderMenu");
  }

  logout() {
    this.$store.dispatch(LOGOUT_USER);
  }
}
